import { Box, Link } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import Picture from 'components/picture';
import { primitive } from 'styles/constants';

import theme from '../theme';

export const ImageContainer = Box.withConfig({
  width: 'full',
  justifyContent: 'center',
  alignItems: 'center',
  paddingY: '$6',
});

export const Image = Picture.withConfig({
  width: '5/6',
  borderRadius: primitive.$borderRadius,
});

export const ImageCaption = withTypography({
  pt: '$4',
  textAlign: theme.imageWidgetCaptionAlign as any,
});

export const ImageCaptionLink = Link.withConfig({
  color: primitive.$fieryRed,
  marginRight: '$2',
  fontSize: 'sm',
});
